import { render, staticRenderFns } from "./BigPrizeTickets.vue?vue&type=template&id=67e8ac8c"
import script from "./BigPrizeTickets.vue?vue&type=script&lang=js"
export * from "./BigPrizeTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports